import Glide, { Controls, Breakpoints, Swipe, Autoplay} from '@glidejs/glide/dist/glide.modular.esm'
import ArrowDisabler from "../frontv2/ArrowDisabler";

const initCorporateGiftCardGlide = () => {
    const glides = document.querySelectorAll(".corporateGlide:not(.lightbox)");
    glides.forEach(glideEl => {
        const glide = new Glide(glideEl, {
            perView: glideEl.dataset.perView ? glideEl.dataset.perView : 3,
            gap: glideEl.dataset.gap ? glideEl.dataset.gap : 10,
            type: 'slider',
            rewind: true,
            bound: true,
            autoplay: glideEl.dataset.autoplay ? glideEl.dataset.autoplay : false,
            breakpoints: {
              600: {
                perView: glideEl.dataset.mobilePerView ? glideEl.dataset.mobilePerView : 1.3
              },
              800: {
                perView: glideEl.dataset.tabletPerView ? glideEl.dataset.tabletPerView : 2.3
              },
              1000: {
                perView: glideEl.dataset.desktopPerView ? glideEl.dataset.desktopPerView : 3.3
              }
            }
          });
          glide.mount({ Controls, Breakpoints, Swipe, ArrowDisabler, Autoplay });
    });
}

export {initCorporateGiftCardGlide}
